<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="bakery_breadcrumb" />
    </div>

    <div class="header">
      <!--      <h1 class="overlay">TREKKING</h1>-->
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container contentDesc">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <div class="title1">
            <h2>
              <strong>{{ $t('pinxba_title') }}</strong>
            </h2>
          </div>
          <div class="title2">
            <h4>{{ $t('pinxba_subtitle1') }}</h4>
          </div>
          <div class="title3">
            <p v-html="$t('pinxba_subtitle2')"></p>
          </div>
        </div>
      </div>
    </div>

    <GallerySlideCarousels :slides="slides" :slide-count="2" :thumb-slide-width="60" />

    <div class="container" v-show="isLang === 0">
      <h2 class="mt-5 mb-5 text-center">SIGNATURE MENU</h2>
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <div class="row d-flex mt-5">
            <div class="col-lg-4 col-12">
              <div class="card">
                <img
                  class="card-img-top"
                  src="@/assets/images/biotopia/bakery_bodyimage09.jpg"
                  alt="Card image cap"
                  style="padding: 10px"
                />
                <div class="card-body">
                  <h5 class="card-title"><strong>핀크스 팥빵</strong></h5>
                  <p class="card-text">
                    핀크스 베이커리의 스테디 셀러 메뉴<br />
                    부드러운 팥 속에 고소한 밤과 호두가 듬뿍 들어간 옛날식 팥빵입니다.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-12">
              <div class="card">
                <img
                  class="card-img-top"
                  src="@/assets/images/biotopia/bakery_bodyimage10.jpg"
                  alt="Card image cap"
                  style="padding: 10px"
                />
                <div class="card-body">
                  <h5 class="card-title"><strong>호두 호떡</strong></h5>
                  <p class="card-text">
                    어릴 적 즐겨 먹던 추억의 맛에 파티쉐의 건강한 레시피를 더한 웰빙 디저트입니다. 제주 감자로 빚어낸
                    담백한 빵 속에 유기농 설탕을 졸여낸 호두가 아낌없이 들어가 달콤한 풍미를 선사합니다.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-12">
              <div class="card">
                <img
                  class="card-img-top"
                  src="@/assets/images/biotopia/bakery_bodyimage12.jpg"
                  alt="Card image cap"
                  style="padding: 10px"
                />
                <div class="card-body">
                  <h5 class="card-title"><strong>쑥찰빵</strong></h5>
                  <p class="card-text">
                    신선한 쑥을 이용해 만든 메뉴.<br />
                    쑥내음 가득한 쫀득한 핀크스 베이커리 쑥찰빵을 즐겨보세요.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-5 mb-5">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <table class="table table-borderless">
            <tbody>
              <tr style="border-bottom: 1px dashed #cdcdcd">
                <td width="27%">{{ $t('pinxba_table_td1') }}</td>
                <td>{{ $t('pinxba_table_td2') }}</td>
              </tr>
              <tr style="border-bottom: 1px dashed #cdcdcd">
                <td>{{ $t('pinxba_table_td3') }}</td>
                <td>07:00 - 22:00</td>
              </tr>
              <tr style="border-bottom: 1px dashed #cdcdcd">
                <td>{{ $t('pinxba_table_td4') }}</td>
                <td v-html="$t('pinxba_table_td5')"></td>
              </tr>
              <tr style="border-bottom: 1px dashed #cdcdcd">
                <td>{{ $t('pinxba_table_td6') }}</td>
                <td>{{ $t('pinxba_table_td7') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!--    <div class="container-fluid text-center pt-5 pb-5 mb-5" style="background-color: #eeeeee" v-show="isLang === 0">
      <h3>추천메뉴 & 프로모션</h3>
    </div>-->
  </div>
</template>

<script>
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'Bakery',
  data() {
    return {
      bakery_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'BAKERY',
        present: this.$t('breadcrumb'),
      },
      slides: [
        {image: require('@/assets/images/biotopia/bakery_bodyimage01.jpg')},
        // {image: require('@/assets/images/biotopia/bakery_bodyimage02.jpg')},
        {image: require('@/assets/images/biotopia/bakery_bodyimage03.jpg')},
        // {image: require('@/assets/images/biotopia/bakery_bodyimage04.jpg')},
        // {image: require('@/assets/images/biotopia/bakery_bodyimage05.jpg')},
        // {image: require('@/assets/images/biotopia/bakery_bodyimage07.jpg')},
        // {image: require('@/assets/images/biotopia/bakery_bodyimage08.jpg')},
      ],
      index: 0, // default: 0,
      isLang: 0,
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.bakery_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'BAKERY',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  components: {
    GallerySlideCarousels,
    Breadcrumb,
  },
};
</script>

<style scoped lang="scss">
.jpword {
  word-break: break-all;
}
.anotherword {
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  td {
    word-break: keep-all;
  }
}
.card-body {
  height: 230px;
}
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/biotopia/bakery_headerimage.jpg');
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "핀크스 베이커리",
    "pinxba_title": "핀크스 베이커리",
    "pinxba_subtitle1": "제주를 닮은, 제주를 담은 로컬 브레드",
    "pinxba_subtitle2": "제주의 신선한 Seasonal 재료에 개성있는 감각을 더하여 건강한 맛을 전해드립니다.<br/>갓 구워낸 30여종의 빵과 케이크 그리고 다양한 쿠키를 만나보세요.",
    "pinxba_table_td1": "위치",
    "pinxba_table_td2": "비오토피아 커뮤니티센터 1F",
    "pinxba_table_td3": "운영시간",
    "pinxba_table_td4": "정기휴일",
    "pinxba_table_td5": "매주 화요일<br /> ※ 업장 사정에 따라 휴일은 변동될 수 있습니다.",
    "pinxba_table_td6": "문의",
    "pinxba_table_td7": "064-793-6000"
  },

  "en":{
    "breadcrumb": "PINX Bakery",
    "pinxba_title": "PINX Bakery",
    "pinxba_subtitle1": "Local bread that resembles and embraces Jeju",
    "pinxba_subtitle2": "Fresh seasonal ingredients of Jeju are mixed with unique sensuousness to offer<br/>healthy taste. Enjoy 30 or more freshly baked bread, cakes, and cookies.",
    "pinxba_table_td1": "Location",
    "pinxba_table_td2": "Community center 1F",
    "pinxba_table_td3": "Opening Hour",
    "pinxba_table_td4": "Closed",
    "pinxba_table_td5": "Every Tuesday<br />※ The day off may change depending on the circumstances.",
    "pinxba_table_td6": "Inquiry",
    "pinxba_table_td7": "+82-64-793-6000"
  },

  "ja": {
    "breadcrumb": "PINX ベーカリー",
    "pinxba_title": "PINX ベーカリー",
    "pinxba_subtitle1": "済州に似た済州を盛り込んだローカルブレッド",
    "pinxba_subtitle2": "済州の新鮮な旬の材料に個性ある感覚をプラスして健康な味を贈ります。<br/>焼きたての30種類以上のパンとケーキ、そして様々なクッキーをお楽しみください。",
    "pinxba_table_td1": "位置",
    "pinxba_table_td2": "コミュニティー・センター 1F",
    "pinxba_table_td3": "運営時間",
    "pinxba_table_td4": "定期休業日",
    "pinxba_table_td5": "First Tuesdays of every month<br />※ The day off may change depending on the circumstances.",
    "pinxba_table_td6": "お問い合わせ",
    "pinxba_table_td7": "+82-64-793-6000"
  }
}
</i18n>
